<template>
  <div class="solve">
    <Sidebanner></Sidebanner>
    <div class="solve_situation">
      <div class="solve_situationbox solve_situationbox3">
        <h2 class="solve_situationbox_title">ANTDIY跨境业务</h2>
        <h3 class="solve_situationbox_subtitle">跨境电商竞争日趋激烈！新手卖家路在何方？</h3>
        <div class="solve_situationbox_line"></div>
        <div class="solve_img"><img src="../assets/solvepc.png" alt="ANTDIY业务场景" v-if="ispc"><img src="../assets/solvemobile.png" alt="ANTDIY业务场景" v-else></div>
        <div class="solve_situation_center">
          <div class="solve_situation_content">
          <div class="solve_situation_box">
          <img src="../assets/solve1.svg" alt="招商入驻">
          <p>招商入驻</p>
          <div>全程协助卖家以最快速度，优先入驻到各大电商平台，同时享受多重优惠政策</div>
        </div>
        <div class="solve_situation_box">
          <img src="../assets/solve2.svg" alt="培训孵化">
          <p>培训孵化</p>
          <div>与第三方培训机构强强联合提供运营培训课程，手把手教会运营技巧及打法，从0-1快速上手</div>
        </div>
        <div class="solve_situation_box">
          <img src="../assets/solve3.svg" alt="软件服务">
          <p>软件服务</p>
          <div>依托ANTDIY强大软件产品生态，ANTDIY为卖家提供从选品到发货的闭环软件服务解决方案</div>
        </div>
        <div class="solve_situation_box">
          <img src="../assets/solve4.svg" alt="云仓服务">
          <p>云仓服务</p>
          <div>ANTDIY战略对接国内多家中转仓及海外仓服务商，为卖家解决采购、发货、海外退货等多项贴心服务</div>
        </div>
        </div>
        </div>    
        <div class="solve_situation_button" @click="consult">立即咨询</div>
      </div>
    </div>
    <div class="solve_situation2">
      <div class="solve_situationbox">
        <h2 class="solve_situationbox_title">招商入驻</h2>
        <h3 class="solve_situationbox_subtitle">全程协助卖家以最快速度，优先入驻到各大电商平台，同时享受多重优惠政策</h3>
        <div class="solve_situationbox_line"></div>
        <div class="solve_invest">
          <div class="solve_invest_box">
            <div class="solve_invest_box_top">
            <p>想转行做跨境电商,</p>
            <p>但又不知道从何入手?</p>
            </div>
            <img src="../assets/solve5.svg" alt="从何入手">
            <div class="solve_invest_box_bottom">
            <em class="solve_invest_box_em1"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct.svg" alt="">
                <span>提供平台分析报告，蓝海平台红利解析</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct.svg" alt="">
                <span>专业人士为您量身推荐平台和运营模式建议</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top">
            <p>不熟悉平台入驻政策,</p>
            <p>不知道如何开店?</p>
            </div>
            <img src="../assets/solve6.svg" alt="如何开店">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em1"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct.svg" alt="">
                <span>提供开店资料包，图文并茂教您一步步提交资料注册店铺</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct.svg" alt="">
                <span>专业人士为您量身推荐平台和运营模式建议</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top">
              <p>店铺审核周期长,</p>
              <p>通过率低?</p>
            </div >
            <img src="../assets/solve7.svg" alt="店铺审核周期长,通过率低">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em1"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct.svg" alt="">
                <span>ANTDIY提供平台专属绿色开店通道</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct.svg" alt="">
                <span>推荐平台招商客户经理联系方式快速了解开
  店进度</span>
              </div>
            </div>                
          </div>
        </div>
        <div class="solve_situation_button solve_situation_button2" @click="consult">立即咨询</div>
      </div>
    </div>
    <div class="solve_situation">
      <div class="solve_situationbox">
        <h2 class="solve_situationbox_title">培训孵化</h2>
        <h3 class="solve_situationbox_subtitle">与第三方培训机构强强联合提供运营培训课程，手把手教会运营技巧及打法，从0-1快速上手</h3>
        <div class="solve_situationbox_line"></div>
        <div class="solve_invest">
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top2">
            <p>店铺申请好,</p>
            <p>不知道怎么运营销售?</p>
            </div>
            <img src="../assets/solve8.svg" alt="从何入手">
            <div class="solve_invest_box_bottom">
            <em class="solve_invest_box_em2"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct3.svg" alt="">
                <span>免费提供各平台运营规则和店铺设置教程</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct3.svg" alt="">
                <span>100+专业卖家交流群让您快速接触行业卖家</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top2">
            <p>运营模式不知道怎么选择,</p>
            <p>铺货还是精品?</p>
            </div>
            <img src="../assets/solve9.svg" alt="如何开店">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em2"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct3.svg" alt="">
                <span>专业讲师为您深度解析各平台各运营模式的优缺点，为您量身推荐运营方式</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct3.svg" alt="">
                <span>更多免费在线课程提供运营技巧讲解</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top2">
              <p>市场培训机构鱼龙混杂,</p>
              <p>价格高昂?</p>
            </div >
            <img src="../assets/solve10.svg" alt="店铺审核周期长,通过率低">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em2"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct3.svg" alt="">
                <span>免费提供各平台运营课程，每周至少1场在线免费直播培训</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct3.svg" alt="">
                <span>专业讲师提供1v1培训服务，让您少走弯路</span>
              </div>
            </div>                
          </div>
        </div>
        <div class="solve_situation_button solve_situation_button2" @click="consult">立即咨询</div>
      </div>
    </div>
    <div class="solve_situation2">
      <div class="solve_situationbox">
        <h2 class="solve_situationbox_title">软件服务</h2>
        <h3 class="solve_situationbox_subtitle">依托ANTDIY云仓强大软件产品生态，ANTDIY为卖家提供从选品到发货的闭环软件服务解决方案</h3>
        <div class="solve_situationbox_line"></div>
        <div class="solve_invest">
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top3">
            <p>想转行做跨境电商,</p>
            <p>但又不知道从何入手?</p>
            </div>
            <img src="../assets/solve11.svg" alt="从何入手">
            <div class="solve_invest_box_bottom">
            <em class="solve_invest_box_em3"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct2.svg" alt="">
                <span>ANTDIY爆款开发功根据选品条件帮您快速筛选出平台各类目热销产品，供卖家跟卖或产品开发</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct2.svg" alt="">
                <span>ANTDIY支持从1688、拼多多、淘宝、Shopee、Lazada、Coupang等60+平台及站点采集产品，一键铺货到各大平台直接进行销售</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top3">
            <p>产品上架复杂效率低?</p>
            <p>翻译麻烦?图片PS困难?</p>
            </div>
            <img src="../assets/solve12.svg" alt="翻译麻烦?图片PS困难?">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em3"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct2.svg" alt="">
                <span> ANTDIY刊登软件支持产品自动采集、描述及图片翻译、图片在线优化等众多人性化功能，0基础也能轻松上手铺货</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct2.svg" alt="">
                <span>支持多平台、多店铺、多产品，批量采集、编辑上架；快捷高效，较纯人工上货，效率提升60倍，成本降低90%</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top3">
              <p>上架产品多，很难管理,</p>
              <p>不知道哪些产品应该下架?</p>
            </div >
            <img src="../assets/solve13.svg" alt="不知道哪些产品应该下架">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em3"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct2.svg" alt="">
                <span>在线商品可实现批量修改价格，标题，图片，库存，描述等操作</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct2.svg" alt="">
                <span>产品库和在线产品实现多平台、多店铺产品管理</span>
              </div>
            </div>                
          </div>
        </div>
        <div class="solve_situation_button solve_situation_button2" @click="consult">立即咨询</div>
      </div>
    </div>
    <div class="solve_situation">
      <div class="solve_situationbox">
        <h2 class="solve_situationbox_title">*云仓服务</h2>
        <h3 class="solve_situationbox_subtitle">ANTDIY战略对接国内多家中转仓及海外仓服务商，为卖家解决采购、入库、质检、贴标、打包、发货、海外退货等多项贴心服务</h3>
        <div class="solve_situationbox_line"></div>
        <div class="solve_invest">
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top4">
            <p>不备货，出单后一单单采购太繁琐?</p>
            </div>
            <img src="../assets/solve14.svg" alt="不备货，出单后一单单采购太繁琐">
            <div class="solve_invest_box_bottom">
            <em class="solve_invest_box_em4"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct4.svg" alt="">
                <span>提供订单批量拍单采购功能，支持淘宝、拼多多、1688、搜款网等多个平台</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct4.svg" alt="">
                <span>提供代采购服务，出单后直接把订单推送到云仓，剩下的事情云仓统统帮您搞定</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top4">
            <p>想备货，但自己没有仓库?想整体</p>
            <p>外包发货，又不知道哪家更靠谱?</p>
            </div>
            <img src="../assets/solve15.svg" alt="上架复杂效率低">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em4"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct4.svg" alt="">
                <span>您无需自行建仓，按需付费即可，为你提供专业的仓储管理服务，量身推荐、定制最优性价比的一站式物流解决方案</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct4.svg" alt="">
                <span>在国际小包专业仓储领域深耘多年有较好的口碑，在国内外设立众多专业电商仓库，能完全满足您国内中转仓和国内外备货仓的相关需求</span>
              </div>
            </div>
          </div>
          <div class="solve_invest_box">
            <div class="solve_invest_box_top solve_invest_box_top4">
              <p>云仓代发货，会丢货吗?时效</p>
              <p>有保证吗?</p>
            </div >
            <img src="../assets/solve16.svg" alt="上架产品多，很难管理">
            <div class="solve_invest_box_bottom">
              <em class="solve_invest_box_em4"></em>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct4.svg" alt="">
                <span>ANTDIY系统与ANTDIY云仓战略合作伙伴强强联合，为您提供成熟的仓储管理解决方案，确保件件有着落，票票有保证
</span>
              </div>
              <div class='solve_invest_box_center'>
                <img src="../assets/correct4.svg" alt="">
                <span>配备智能化的物流分拣设备，免费提供拆包验货服务，货物流转全程追踪，最大化降低错发、漏发事件，出错包赔</span>
              </div>
            </div>                
          </div>
        </div>
        <div class="solve_situation_button solve_situation_button2" @click="consult">立即咨询</div>
      </div>
    </div>
    <div class="solve_situation2">
      <div class="solve_situationbox solve_situationbox4">
        <h2 class="solve_situationbox_title">跨境电商一站式解决方案</h2>
        <h3 class="solve_situationbox_subtitle">您专注卖货-爆单-收钱,其他的,统统交给我们帮您一站搞定！</h3>
        <div class="solve_situationbox_line"></div>
        <div class="product_planbox1">
          <h3 class="product_planbox1_title" >传统跨境，道阻且长</h3>
          <div><img src="../assets/productcn3.svg" alt="传统跨境，道阻且长" ></div>
        </div>
        <div class="product_planbox2">
          <h3 class="product_planbox1_title">ANTDIY系统+生态服务 实现轻资产，高效率的跨境电商路径</h3>
          <div><img src="../assets/productcn4.svg" alt="ANTDIY系统+生态服务 实现轻资产，高效率的跨境电商路径" ></div>
        </div>
        <div class="solve_situation_button solve_situation_button2" @click="consult">立即咨询</div>
      </div>
    </div>
    <div class="solve_situation3">
      <div class="solve_situationbox">
        <h2 class="solve_situationbox_title">ANTDIY操作流程</h2>
        <h3 class="solve_situationbox_subtitle" v-if="ispc">十大主流平台，各渠道产品资料共享，多角色工作协同开展</h3>
        <h3 class="solve_situationbox_subtitle" v-if="ispc==false">十大主流平台，各渠道产品资料共享，多角色工作</h3>
        <h3 class="solve_situationbox_subtitle" v-if="ispc==false">协同开展</h3>
        <div class="solve_situationbox_line"></div>
        <div class="solve_operator_box"><img src="../assets/solve17.png" alt="ANTDIY操作流程" class="solve_operator" ></div>
      </div>
    </div>
    <div class="solve_situation">
      <div class="solve_situationbox solve_situationbox2">
        <h2 class="solve_situationbox_title">订单处理流程</h2>
        <h3 class="solve_situationbox_subtitle" v-if="ispc">十大主流平台，各渠道产品资料共享，多角色工作协同开展</h3>
        <h3 class="solve_situationbox_subtitle" v-if="ispc==false">十大主流平台，各渠道产品资料共享，多角色工作</h3>
        <h3 class="solve_situationbox_subtitle" v-if="ispc==false">协同开展</h3>
        <div class="solve_situationbox_line solve_situationbox_line2"></div>
        <div class="solve_handle">
          <div class="solve_handle_content">
            <img src="../assets/solve18.svg" alt="01">
            <div class="solve_handle_content_content">
              <h1>01</h1>
              <h2>客户下单</h2>
              <h3>客户在您的店铺里下单</h3>
            </div>
          </div>
        </div>
        <div class="solve_handle solve_handle2">
          <div class="solve_handle_content">
            <img src="../assets/solve19.svg" alt="02">
            <div class="solve_handle_content_content">
              <h1>02</h1>
              <h2>订单同步</h2>
              <h3>在线处理平台订单，订单自动同步到云仓</h3>
            </div>
          </div>
        </div>
        <div class="solve_handle">
          <div class="solve_handle_content">
            <img src="../assets/solve20.svg" alt="03">
            <div class="solve_handle_content_content">
              <h1>03</h1>
              <h2>云仓采购</h2>
              <h3>通过云仓采购模块，批量在1688、淘宝、拼多多平台采购</h3>
            </div>
          </div>
        </div>
        <div class="solve_handle solve_handle2">
          <div class="solve_handle_content">
           <img src="../assets/solve21.svg" alt="04">
            <div class="solve_handle_content_content">
              <h1>04</h1>
              <h2>质检入库</h2>
              <h3>商品发送到ANTDIY云仓，质检入库</h3>
            </div>
          </div>
        </div>
        <div class="solve_handle">
          <div class="solve_handle_content">
            <img src="../assets/solve22.svg" alt="05">
            <div class="solve_handle_content_content">
              <h1>05</h1>
              <h2>物流发货</h2>
              <h3>云仓根据订单信息、打包发货、物流商揽收</h3>
            </div>
          </div>
        </div>
        <div class="solve_handle solve_handle2">
          <div class="solve_handle_content">
            <img src="../assets/solve23.svg" alt="06">
            <div class="solve_handle_content_content">
              <h1>06</h1>
              <h2>同步信息</h2>
              <h3>发货信息自动同步到平台，发货成功</h3>
            </div>
          </div>
        </div>
        <div class="solve_handle">
          <div class="solve_handle_content">
            <img src="../assets/solve24.svg" alt="07">
            <div class="solve_handle_content_content">
              <h1>07</h1>
              <h2>售后保障</h2>
              <h3>在线客服模版，售后无忧</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  <FooterCN></FooterCN>
  </div>
</template>

<script>
import FooterCN from './common/footerCN.vue'
import Sidebanner from './common/sidebanner.vue'
export default {
  name:'solve',
  components:{
    FooterCN,
    Sidebanner
  },
  data(){
    return{
      data(){
        return{
          ispc:true
        }    
      }
    }
  },
  methods:{
    consult(){
      if (window.fcWidget.isLoaded()) {
        window.fcWidget.open()
      }
    }
  },
  created(){
    document.title = '全球云店——想法即商业，开店即开张';;
    if(document.body.offsetWidth>767){
      this.ispc=true
    }else{
      this.ispc=false
    }   
  }
}
</script>

<style scoped>
.solve_situation{
  width: 100%;
}
.solve_situation2{
  width: 100%;
  background: #FDF5F2;
}
.solve_situation3{
  width: 100%;
  background-image: url('/static/imgs/solveback.svg');
  background-repeat: no-repeat;
  background-size: cover;
}
.solve_img img{
  width: 100%;
  transform: scale(1.1);
}
.solve_situationbox{
  width: 1200px;
  margin:auto;
  padding: 80px 0;
}
.solve_situationbox3{
  width: 100%;
}
.solve_situationbox2{
  height: 2220px;
}
.solve_situationbox_title{
  font-family: SourceHanSansCN-Bold;
  font-size: 36px;
  color: #222536;
  letter-spacing: 0.5px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 30px 0;
}
.solve_operator{
  width: 1200px;
}
.solve_situationbox_subtitle{
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0.28px;
  font-weight: 500;
  text-align: center;
}
.solve_situationbox_line{
  width: 60px;
  height: 8px;
  background: #FC5421;
  border-radius: 6px;
  margin:24px auto 60px auto;
}
.solve_situationbox_line2{
  margin-bottom: 0;
}
.solve_situation_center{
  width: 100%;
}
.solve_situation_content{
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 30px auto 0;
}
.solve_situation_box{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 58px 17px 42px 15px;
  width: 292px;
}
.solve_situation_box img{
  width: 95px;
  height: 78.32px;
}
.solve_situation_box p{
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 700;
  margin: 30px 0 15px;
}
.solve_situation_box div{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #8D919B;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 24px;
  font-weight: 400;
}
.solve_situation_button{
  width: 114px;
  height: 48px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  font-weight: 500;
  line-height: 48px;
  text-align: center;
  margin:18px auto 0;
  cursor: pointer;
}
.solve_situation_button2{
  margin: 60px auto 0;
}
.solve_situation_button:hover{
  background: #E34A1E;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
}
.solve_invest{
  display: flex;
  justify-content: space-between;
}
.solve_invest_box{
  width: 386px;
  padding-bottom: 30px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(159,37,0,0.07);
  border-radius: 20px;
}
.solve_invest_box_top{
  width: 100%;
  height: 112px;
  background-image: linear-gradient(180deg, #FE8B47 0%, #FC5322 100%);
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.solve_invest_box_top2{
  background-image: linear-gradient(180deg, #69C0FF 0%, #1890FF 100%);
}
.solve_invest_box_top3{
  background-image: linear-gradient(180deg, #FF8C86 0%, #F75D59 100%);
}
.solve_invest_box_top4{
  background-image: linear-gradient(180deg, #8BA9FF 0%, #597EF7 100%);
}
.solve_invest_box p{
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 26px;
  font-weight: 700;
}
.solve_invest_box img{
  width: 269.39px;
  height: 198px;
  margin: 26px auto;
  display: block;
}
.solve_invest_box_em1{
  width: 100%;
  height: 1px;
  opacity: 0.18;
  border-bottom: 1px solid rgba(251,84,33,1);
  display: block;
}
.solve_invest_box_em2{
  width: 100%;
  height: 1px;
  opacity: 0.18;
  border-bottom: 1px solid rgba(54,162,255,1);
  display: block;
}
.solve_invest_box_em3{
  width: 100%;
  height: 1px;
  opacity: 0.18;
  border-bottom: 1px solid rgba(255,53,48,1);
  display: block;
}
.solve_invest_box_em4{
  width: 100%;
  height: 1px;
  opacity: 0.18;
  border-bottom: 1px solid rgba(54,162,255,1);
  display: block;
}

.solve_invest_box_center{
  display: flex;
  margin-top: 12px;
  align-items: baseline;
}
.solve_invest_box_center img{
  width: 15.59px;
  height: 14.31px;
  margin: 0 10.5px 0 0;
}
.solve_invest_box_center span{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #8D919B;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 400;
}
.solve_invest_box_bottom{
   padding: 0 20px;
}
.product_planbox1{
  width:100%;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 1px rgba(141,33,0,0.04);
  border-radius: 11px;
  padding-bottom: 25px;
}
.product_planbox1 div{
  display: flex;
  justify-content: center;
}
.product_planbox2 div{
  display: flex;
  justify-content: center;
}
.product_planbox1_title{
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  color: #222536;
  letter-spacing: 0.33px;
  text-align: center;
  font-weight: 700;
  padding: 30px 0;
}
.product_planbox2{
  width:100%;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 1px rgba(141,33,0,0.04);
  border-radius: 11px;
  margin: 40px 0 0 0;
  padding-bottom: 25px;
}
.solve_handle{
  width: 956px;
  height: 154px;
  background: #FFFFFF;
  box-shadow: 0px 6px 18px 0px rgba(207,207,207,0.5);
  border-radius: 20px;
  position: relative;
  float: left;
  margin-top: 120px;
}
.solve_handle2{
  float: right;
}
.solve_handle_content{
  position: absolute;
  display: flex;
  align-items: center;
  bottom: 21px;
  left: 65px;
}
.solve_handle_content img{
  width: 205px;
  height: 186px;
}
.solve_handle_content_content{
  margin-left: 60px;
}
.solve_handle_content_content h1{
  font-family: MicrosoftSansSerif;
  font-size: 70px;
  color: #FB5421;
  letter-spacing: 2.33px;
  text-align: justify;
  font-weight: 400;
}
.solve_handle_content_content h2{
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  color: #222536;
  letter-spacing: 0.8px;
  text-align: justify;
  line-height: 30px;
  font-weight: 700;
  margin: 15px 0 10px;
}
.solve_handle_content_content h3{
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0;
  font-weight: 400;
}
@media(max-width: 767px){
.solve_img img{
  transform: none;
}
.solve_situation3{
  width: 100%;
}
.solve_situationbox{
  width: 100%;
  margin:auto;
  padding: .65rem .48rem .8rem .48rem;
}
.solve_situationbox3{
  padding: 1.65rem 0 .8rem 0;
}
.solve_situationbox4{
  padding: .65rem 0 .8rem 0;
}
.solve_situationbox2{
  height: auto;
}
.solve_situationbox_title{
  font-size: .48rem;
  letter-spacing: 0;
  margin: 0 0 .4rem 0;
}
.solve_situationbox_subtitle{
  font-size: .24rem;
  letter-spacing: 0.0033rem;
}
.solve_situationbox_line{
  width: .6rem;
  height: .08rem;
  background: #FC5421;
  border-radius: .06rem;
  margin:.25rem auto .7rem auto;
}
.solve_situationbox_line2{
  margin-bottom: 0;
}
.solve_situation_center{
  padding: 0 .48rem;
}
.solve_situation_content{
  margin-top: .56rem;
  flex-wrap: wrap;
  width: 100%;
}
.solve_situation_box{
  padding: .45rem .22rem .45rem .22rem;
  width: 3rem;
}
.solve_situation_box img{
  width: .725rem;
  height: .62rem;
}
.solve_situation_box p{
  font-size: .22rem;
  letter-spacing: 0.0055rem;
  margin: .3rem 0 .2rem;
}
.solve_situation_box div{
  font-size: .18rem;
  letter-spacing: 0.0056rem;
  line-height: .24rem;
}
.solve_situation_button{
  width: 1.51rem;
  height: .56rem;
  box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
  border-radius: .08rem;
  font-size: .24rem;
  letter-spacing: 0.0075rem;
  line-height: .56rem;
  margin:.25rem auto 0;
}
.solve_situation_button2{
  margin: .2rem auto 0;
}
.solve_operator_box{
  overflow: auto;
}
.solve_invest{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.solve_invest_box{
  width: 100%;
  padding-bottom: .5rem;
  box-shadow: 0px .02rem .1rem 0px rgba(159,37,0,0.07);
  border-radius: .2rem;
  margin-bottom: .3rem;
}
.solve_invest_box_top{
  width: 100%;
  height: 1.2rem;
  border-radius: .2rem .2rem 0 0;
}
.solve_invest_box p{
  font-size: .28rem;
  letter-spacing: 0.007rem;
  line-height: .36rem;
}
.solve_invest_box img{
  width: 4.47rem;
  height: 3.25rem;
  margin: .26rem auto;
}
.solve_invest_box_center{
  margin-top: .25rem;
  align-items: initial;
}
.solve_invest_box_center img{
  width: .264rem;
  height: .242rem;
  margin: 0 .175rem 0 0;
}
.solve_invest_box_center span{
  font-size: .2rem;
  line-height: .3rem;
}
.solve_invest_box_bottom{
   padding: 0 .32rem;
}
.product_planbox1{
  height: auto;
  width:100%;
  box-shadow:none;
  border-radius: 0;
  padding-bottom: 0;
  padding: 0 .48rem;
}
.product_planbox1 div{
  display: block;
  padding-bottom: .6rem;
  overflow: auto;
}
.product_planbox2 div{
  display: block;
  overflow: auto;
  padding-bottom: .6rem;
}
.product_planbox1_title{
  width: 4.83rem;
  font-size: .3rem;
  padding: .4rem 0 .5rem 0;
  margin:auto
}
.product_planbox2{
  height: auto;
  width:100%;
  box-shadow:none;
  border-radius: 0;
  padding: 0 .48rem;
  margin: .4rem 0 .5rem 0;
  padding-bottom: 0;
}
.solve_handle{
  width: 100%;
  height: 1.12rem;
  box-shadow: 0px .06rem .18rem 0px rgba(207,207,207,0.5);
  border-radius: .2rem;
  float: none;
  margin-top: 1.2rem;
}
.solve_handle2{
  float: none;
}
.solve_handle_content{
  position: absolute;
  display: flex;
  bottom: .21rem;
  left: .45rem;
  align-items: flex-end;
  padding-right: .2rem;
}
.solve_handle_content img{
  width: 1.28rem;
  height: 1.28rem;
}
.solve_handle_content_content{
  margin-left: .357rem;
}
.solve_handle_content_content h1{
  font-size: .5rem;
  letter-spacing: .0167rem;
}
.solve_handle_content_content h2{
  font-size: .22rem;
  letter-spacing: 0.0073rem;
  line-height: .3rem;
  margin: .1rem 0 .08rem;
}
.solve_handle_content_content h3{
  font-size: .18rem;
}
}
</style>


// WEBPACK FOOTER //
// src/components/solve.vue